import React from "react";
import classnames from 'classnames';

const How = props => {

  const{name, email} = props.errors

  return (
    <div id="how-section" className="conatainer how-section">
      <h1 className="how-heading">
        How it <span className="highlight">Works </span>?
      </h1>
      <div className="row how-img-col">
        <img
          src="/images/how-legacy-works.svg"
          alt=""
          className="how-img img-fluid"
        />
        <img
          src="/images/how-legacy-work.svg"
          alt=""
          className="mob-how-img"
        />
      </div>
      <div id="signup" className="newsletter">
        <h1 className="newsletter-heading">
          The goal isn't to live forever. The goal is to create something that
          will.
        </h1>
        <h3 className="newsletter-sub-heading">
          Start building your legacy today for a better tomorrow.
        </h3>
        <input
          type="text"
          className={classnames("name", {
             'is-invalid': name
          })}
          placeholder="Enter your Full Name"
          name="username"
          value={props.name}
          onChange={props.onChange.bind(this, "name")}
        />
        {name && <div className="invalid-feedback">{name}</div>}
        <input
          type="email"
          className={classnames("mail", {
            'is-invalid': email
         })}
          placeholder="Enter your Email"
          name="email" 
          value={props.email}
          onChange={props.onChange.bind(this, "email")}
        />
        {email && <div className="invalid-feedback">{email}</div>}

        <button
          type="button"
          className="newsletter-button"
          onClick={props.handleSubmit.bind(this)}
        >
          Build your Legacy
        </button>
      </div>
    </div>
  );
};

export default How;



// WEBPACK FOOTER //
// ./src/Components/LandingPage/How.js